import * as React from 'react';
import {Platform} from 'react-native';
import NumberFormat from 'react-number-format';

import Text from '/component/base/Text';
import {CURRENCY_SYMBOL} from '/enum/currency.enum';
import {LABEL_COMING_SOON, LABEL_SPLIT_COMING_SOON} from '/enum/label.enum';
import {getFontFamily} from '/util/text.util';

import {styles} from './FormattedNumber.style';
import {getTransformedValue} from './InlineFromattefNumber.util';

export const InlineFormattedNumber = ({
  style: styleProp,
  textVariant = 'body',
  textEmphasis = 'high',
  boldText = true,
  value = 0,
  currencyCode = null,
  decimalPlaces = 0,
  decimalSymbol = '.',
  separator = ',',
  separationStyle = 'thousand',
  testID = null,
  truncate = false,
  preserveNegative = false,
}: any) => {
  const textStyle = {
    // @ts-expect-error TS(2339): Property 'text' does not exist on type '{ comingSo... Remove this comment to see the full error message
    ...styles.text,
    ...(boldText ? getFontFamily('bold') : {}),
    ...(styleProp || {}),
  };
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const currencySymbol = CURRENCY_SYMBOL[currencyCode];
  const renderedPrefix = value >= 0 ? currencySymbol : `- ${currencySymbol}`;
  //HIDDEN: CONNAPP-584
  // const renderedSuffix = currencyCode ? ` ${currencyCode}` : '';

  // All non-currency numbers <= 9999 should omit comma separators
  if (!currencyCode) {
    separator = value <= 9999 ? '' : separator;
  }

  // TODO: get rid of this code once all pre-computed metrics are integrated
  if (value === LABEL_COMING_SOON || value === LABEL_SPLIT_COMING_SOON) {
    return (
      <Text
        allowFontScaling
        maxFontSizeMultiplier={2}
        testID={testID}
        style={[textStyle, styles.comingSoon]}
        variant={textVariant}
        emphasis={textEmphasis}
        accessible={true}
        accessibilityLabel={String(value)}>
        {value}
      </Text>
    );
  }

  const formattedValue = getTransformedValue({
    value,
    truncate,
    preserveNegative,
  });

  return (
    <NumberFormat
      displayType="text"
      value={formattedValue}
      decimalSeparator={decimalSymbol}
      thousandSeparator={separator}
      thousandsGroupStyle={separationStyle}
      decimalScale={decimalPlaces}
      fixedDecimalScale={true}
      renderText={renderedValue => (
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          testID={testID}
          style={textStyle}
          variant={textVariant}
          emphasis={textEmphasis}
          accessible={Platform.OS == 'ios'}>
          {!!currencySymbol && renderedPrefix}
          {renderedValue}
          {/*{renderedSuffix}*/}
        </Text>
      )}
    />
  );
};

export default InlineFormattedNumber;
